<template lang="html">
  <div class="originSelect">
    <select class="" name="" @change="changeEvent" v-if="dataType === 'number'">
      <option :value="index" v-for="(item, index) in data" :selected="(index+1) == defValue">{{item}}</option>
    </select>

    <select class="" name="" @change="changeEvent" v-else-if="selectObj == 'service' || selectObj == 'grads'">
      <option v-if="defValue">{{defValue}}</option>
      <option :value="index" :selected="index == valIndex"  v-for="(item, index) in data">{{item.name}}</option>
    </select>
    
    <select class="" name="" @change="changeEvent" v-else>
      <option :value="index" v-for="(item, index) in data" 
              :selected="(index+1) == defValue">{{item.name}}</option>
    </select>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valIndex: -1,
      dataType: ''
    }
  },
  created() {
    this.$nextTick(()=>{
      this.dataType = typeof(this.data)
      if (this.selectObj === 'service' || this.selectObj === 'grads') {
        for (let i = 0; i < this.data.length; i++) {
          const item = this.data[i]
          if (item.id == this.selectId) {
            this.valIndex = i 
            break
          }
        }
      }
    })
  },
  props:['data', 'selectId', 'defValue', 'selectObj'],
  methods: {
    changeEvent(e) {
      // debugger
      
      let index = parseInt(e.target.value)
     
      if(this.dataType === 'number') {
        this.$emit('selecter', {'key': this.selectObj, 'value': index+1})
      }else {

        this.$emit('selecter', {'key': this.selectObj, 'value': !isNaN(index) ? this.data[index].name: e.target.value, 'index': index})
        
      }

    }
  }
}
</script>

<style lang="scss">
  .originSelect{
    display: inline-block;
    select{
      -webkit-appearance: none;
       -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      width: 100px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #e6e6e6;
      text-align: center;
      background: url("../../assets/img/arrow-down.png") no-repeat;
      background-position: right 10px center;
      padding-left: 10px;
      color: #666;
      option{
        height: 40px;
        line-height: 40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// originSelect.vue?2cf695ee